// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC","li":"Pagination_li__Kb01L","a":"Pagination_a__MIhgj","buttonDisabled":"Pagination_buttonDisabled__mILnJ"};